<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" :class="!isDetail && 'isDetail'" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { ref } from 'vue';

const props = withDefaults(
  defineProps<{ isDetail?: boolean; pageNo?: string }>(),
  {
    isDetail: false,
    pageNo: '01'
  }
);

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 76.971 55.905">
    <g id="yema3" transform="translate(-947.029 -7.341)">
      <g id="组_4664" data-name="组 4664" transform="translate(572.814 -165)">
        <text id="_01" data-name="01" transform="translate(393.67 206.341)" fill="var(--theme-color-1)" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
        <path id="路径_5243" data-name="路径 5243" d="M-14410.848-2821.15h30.447l13.53,8.659,3.414-8.659h29.579" transform="translate(14785.063 3038.491)" fill="none" stroke="var(--theme-color-1)" stroke-width="3"/>
      </g>
    </g>
  </svg>
`);
</script>
<style lang="scss" scoped>
@import './index.scss';
.isDetail {
  position: absolute;
  bottom: 20px;
  right: 10px;
}
</style>
